import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const CertificateOfCompletionCompletedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.CERTIFICATE_OF_COMPLETION_COMPLETED),
  documents: z.array(z.string()),
});

export type CertificateOfCompletionCompletedTaskAttempt = z.infer<
  typeof CertificateOfCompletionCompletedTaskAttemptSchema
>;

export const CertificateOfCompletionCompletedTaskAttemptFormSchema = z.object({
  type: z.literal(TaskType.CERTIFICATE_OF_COMPLETION_COMPLETED),
});
